import * as React from 'react';
import Translator from './Translator';

interface TranslatorInjectParentProps {
    parentPath: string
}

class TranslatorInjectParent extends React.Component <TranslatorInjectParentProps, {}> {
    public constructor(props: TranslatorInjectParentProps) {
        super(props);
        this.traverseChildren = this.traverseChildren.bind(this);
    }

    public traverseChildren(children: any, path: string) {
        return React.Children.map(children, (child: React.ReactElement<any>) => {
            if (!child || !child.props)
                return child;

            if (child.type === Translator)
                return React.cloneElement(child, {
                    parentPath: path
                });
            
            if (child.type === TranslatorInjectParent) {
                path = path + "." + child.props.parentPath
                child = React.cloneElement(child, {
                    parentPath: path
                });
            }

            if (child.props.children)
                return React.cloneElement(child, {
                    children: this.traverseChildren(child.props.children, path)
                });

            return child;
        });
    }

    public render() {
        return this.traverseChildren(this.props.children, this.props.parentPath);
    }
}

export default TranslatorInjectParent;


// WEBPACK FOOTER //
// ./src/Components/Translator/TranslatorInjectParent.tsx